<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "SIM-Karten Informationen"}}</h4>
</div>
<div class="modal-body">
	{{#if requestDone}}
		{{#if connectionInfos}}
			<div class="row" >
				{{#each connectionInfos}}
					<div class="col-xs-12 col-lg-6">
						<div id="js-{{@index}}">
							<h4 class="text-dark heading m-b-15">{{header}}</h4>
							<dl class="dl-horizontal long">
								{{#each fields}}
								{{#if value}}
									<dt>{{name}}</dt>
									<dd>{{value}}</dd>
								{{else}}
								{{#COMPARE name "===" "divider"}}
								<br class="hidden-xs">
								{{/COMPARE}}
								{{/if}}
								{{/each}}
							</dl>
							<div class="text-center">{{special}}</div>
						</div>
					</div>
				{{/each}}
			</div>
		{{else}}
			<div class="alert alert-danger m-t-20">{{error}}</div>
		{{/if}}
	{{else}}
		<div>
			<i class="fa fa-spin fa-spinner"></i><span> {{TR "Daten werden geladen"}} ...</span>
		</div>
	{{/if}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Schließen"}}</button>
</div>
